import { render, staticRenderFns } from "./responsibility.vue?vue&type=template&id=2500a736&scoped=true"
import script from "./responsibility.vue?vue&type=script&lang=js"
export * from "./responsibility.vue?vue&type=script&lang=js"
import style0 from "./responsibility.vue?vue&type=style&index=0&id=2500a736&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2500a736",
  null
  
)

export default component.exports